import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess1010Status: 'idle',
    startProcess1010Error: undefined as any,
    loadUserParamsProcess1010Status: 'idle',
    loadUserParamsProcess1010Error: undefined as any,

    process1010List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess1010 = createAsyncThunk('process1010Slice/startProcess1010', async ({ process1010 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess1010/`,
        prepareData(process1010),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess1010Status } = getState().process1010Slice
        return startProcess1010Status !== 'pending'
    }
})

export const loadUserParamsProcess1010 = createAsyncThunk('process1010Slice/loadUserParamsProcess1010', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess1010/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess1010Status } = getState().process1010Slice
        return loadUserParamsProcess1010Status !== 'pending'
    }
})

const Process1010Slice = createSlice({
    name: 'process1010Slice',
    initialState,
    reducers: {
        resetstartProcess1010: (state) => {
            state.job = undefined
            state.startProcess1010Error = undefined
        },
        resetstartProcess1010Error: (state) => {
            state.startProcess1010Error = undefined
        },
        resetloadUserParamsProcess1010: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess1010Error = undefined
        },
        resetloadUserParamsProcess1010Error: (state) => {
            state.loadUserParamsProcess1010Error = undefined
        },
        removeFromProcess1010ListById: (state, action) => {
            state.process1010List = state.process1010List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess1010ListByIds: (state, action) => {
            state.process1010List = state.process1010List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process1010List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess1010Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process1010List = []
            state.startProcess1010Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess1010.pending, (state) => {
            state.startProcess1010Status = 'pending'
            state.startProcess1010Error = undefined
        })
        builder.addCase(startProcess1010.fulfilled, (state, action) => {
            state.startProcess1010Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess1010.rejected, (state, action) => {
            state.startProcess1010Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess1010Error = action.error.message
            } else {
                state.startProcess1010Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess1010.pending, (state) => {
            state.loadUserParamsProcess1010Status = 'pending'
            state.loadUserParamsProcess1010Error = undefined
        })
        builder.addCase(loadUserParamsProcess1010.fulfilled, (state, action) => {
            state.loadUserParamsProcess1010Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess1010.rejected, (state, action) => {
            state.loadUserParamsProcess1010Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess1010Error = action.error.message
            } else {
                state.loadUserParamsProcess1010Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess1010,
    resetstartProcess1010Error,
    resetloadUserParamsProcess1010,
    resetloadUserParamsProcess1010Error,
    removeFromProcess1010ListById,
    removeFromProcess1010ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process1010Slice.actions
export default Process1010Slice.reducer
